import { render, staticRenderFns } from "./SelectorCidade.vue?vue&type=template&id=ee859168&scoped=true"
import script from "./SelectorCidade.vue?vue&type=script&lang=js"
export * from "./SelectorCidade.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee859168",
  null
  
)

export default component.exports